/** @jsx jsx */
import {jsx, css} from '@emotion/react'

const Section = ({title, image, children}) => {
    return (
        <section
            css={css`
                p {
                    margin: 2rem 0;
                    font-size: 1.1rem;
                    @media (max-width: 600px) {
                        font-size: 1rem;
                    }
                }
                ol {
                    list-style-position: inside;
                    padding: 0;
                }
                li {
                    margin: 1rem 0;
                    font-size: 1.1rem;
                    @media (max-width: 600px) {
                        font-size: 1rem;
                    }
                }
            `}
        >
            <h2
                css={css`
                    margin: 2rem 0;
                    font-size: 1.5rem;
                    font-size: min(max(1.25rem, 3vw), 2rem);
                `}
            >
                {title}
            </h2>
            {image && (
                <img
                    src={image}
                    alt="section"
                    css={css`
                        width: 100%;
                    `}
                />
            )}

            {children}
        </section>
    )
}

export default Section
